export interface IInvoice {
  id?: any;
  tableName?: string;
  guestCount?: number;
  status?: string;
  waiter?: string;
  invoicePrice?: number;
  tip?: number;
  extendedPaymentMethod?: string;
  redeemedVoucher?: number;
  invoiceCreateDate?: Date | null;
  invoiceCancelDate?: Date | null;
  invoiceCancelReason?: string;
  tseCounter?: number;
  tseProcessData?: string;
  tseSignature?: string;
  tseError?: boolean;
  sequenceId?: number;
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
}

export const defaultValue: Readonly<IInvoice> = {
  id: '',
  tableName: '',
  guestCount: 0,
  status: '',
  waiter: '',
  invoicePrice: 0,
  tip: 0,
  extendedPaymentMethod: '',
  redeemedVoucher: 0,
  invoiceCreateDate: null,
  invoiceCancelDate: null,
  invoiceCancelReason: '',
  tseCounter: 0,
  tseProcessData: '',
  tseSignature: '',
  tseError: false,
  sequenceId: 0,
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
};
